import { handleActions } from 'redux-actions';
import {
  dadataSearchBank,
  dadataSearchBankSuccess,
  dadataSearchBankFailure,
  dadataSetBank,
  dadataIdleBank,
} from '../actions';
import { combineReducers } from 'redux';

const result = handleActions(
  {
    [dadataSearchBankSuccess]: (state, { payload }) => payload,
  },
  []
);

const selected = handleActions(
  {
    [dadataSetBank]: (state, { payload }) => payload,
    [dadataIdleBank]: () => {
      return {};
    },
  },
  {}
);

const status = handleActions(
  {
    [dadataSearchBank]: () => 'validating',
    [dadataSearchBankSuccess]: () => 'success',
    [dadataSearchBankFailure]: () => 'error',
  },
  'IDLE'
);

export const dadataBank = combineReducers({
  result,
  status,
  selected,
});
